import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Segment from "semantic-ui-react/dist/es/elements/Segment/Segment.js";
import { size } from "../../../utils/size";
import { ResponsiveImage } from "../ResponsiveImage";
import { DEFAULT_BOTTOM_OFFSET } from "./constants";
export var Component = function Component(_ref) {
  var bottomOffset = _ref.bottomOffset,
      className = _ref.className,
      children = _ref.children,
      hasGradient = _ref.hasGradient,
      imageUrl = _ref.imageUrl,
      placeholderImageUrl = _ref.placeholderImageUrl,
      sizes = _ref.sizes,
      srcSet = _ref.srcSet;
  return React.createElement(Segment, {
    className: classnames(className, 'full-bleed', {
      'has-gradient': hasGradient,
      'has-children': size(children) > 0
    }),
    style: {
      '--full-bleed-bottom-offset': bottomOffset
    },
    vertical: true
  }, React.createElement(ResponsiveImage, {
    imageUrl: imageUrl,
    isFluid: true,
    placeholderImageUrl: placeholderImageUrl,
    sizes: sizes,
    srcSet: srcSet,
    willFill: true
  }), children);
};
Component.displayName = 'FullBleed';
Component.defaultProps = {
  bottomOffset: DEFAULT_BOTTOM_OFFSET,
  children: null,
  className: '',
  hasGradient: false,
  imageUrl: null,
  placeholderImageUrl: null,
  sizes: null,
  srcSet: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  bottomOffset: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  hasGradient: PropTypes.bool,
  imageUrl: PropTypes.string,
  placeholderImageUrl: PropTypes.string,
  sizes: PropTypes.string,
  srcSet: PropTypes.string
} : {};